<template>
    <div>
        <h1>{{ title }}</h1>

        <h2> - {{ company_name }} - </h2>

        <div class="spacer-small"></div>
        
        <div class="kgk-text">Vom <b>{{ convertToGermanFormat(this.challenge.start_date) }}</b> bis <b>{{ convertToGermanFormat(this.challenge.stop_date) }}</b> lädt die {{ this.company_name }} Sie herzlich ein, an unserer {{ this.challenge.name }} teilzunehmen. Zeigen Sie Teamgeist und Motivation, indem Sie gemeinsam Schritte und so Kilometer gegen Krebs sammeln.<br><br>
            <b>Unser Ziel:</b> Wenn wir es schaffen, gemeinsam <b>{{ convertNumberReadable(this.challenge.target) }}</b> Schritte zurückzulegen, spenden wir <b>{{convertNumberReadable(this.challenge.donate)}}</b> Euro an die Krebsgesellschaft NRW e.V. Das Geld unterstützt den Ausbau und Erhalt der Krebsberatungsstellen – ein wichtiges und kostenloses Angebot für Betroffene und Angehörige.<br><br>
            Machen Sie mit und setzen Sie ein Zeichen: für mehr Bewegung, Gemeinschaft und eine gute Sache!</div> 

        <div v-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-else-if="users">
            <table>
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                        <th class="kgk-left">Benutzername</th>
                        <th>Team</th>
                        <th style="white-space:nowrap">Anzahl Läufe</th>
                        <th>Gelaufene Schritte</th>
                        <th>Gelaufene Kilometer</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(user, index) in users"
                        :key="user.identifier">
                        <td>
                            <div class="kgk-mobile-th">Platzierung:</div>
                            <span class="kgk-ranking-num">{{ index + 1 }}.</span>
                        </td>
                        <td style="padding-top:8px;padding-bottom:8px;">
                            <a class="kgk-avatar kgk-avatar--list" v-if="user.avatar_url" :href="user.avatar_url" @click.prevent="" v-kgk-avatar="user.avatar_url"></a>
                            <div class="kgk-avatar kgk-avatar--list" v-else v-kgk-avatar="user.avatar_url"></div>
                        </td>
                        <td class="kgk-left">
                            <div class="kgk-mobile-th">Benutzername:</div>
                            {{ user.username }}
                        </td>
                        <td class="kgk-center">
                            <div class="kgk-mobile-th">Team:</div>
                            {{ user.team_name }}
                        </td>
                        <td class="kgk-center">
                            <div class="kgk-mobile-th">Anzahl Läufe:</div>
                            {{ user.run_count }}
                        </td>
                        <td class="kgk-center">
                            <div class="kgk-mobile-th">Gelaufene Schritte:</div>
                            <strong>{{  convertNumberReadable(user.total_steps,2) }}</strong>
                        </td>
                        <td class="kgk-center">
                            <div class="kgk-mobile-th">Gelaufene Kilometer:</div>
                            <strong>{{ convertNumberReadable(user.total_steps_multiplied,2) }} km</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else-if="error">
            <p>Fehler: {{error}}</p>
        </div>
    </div>
</template>

<script>
    import leaderboard from '../../api/leaderboard';

    export default {
        name: 'LeaderboardCompanysteps',
        props: {
            title: {
                type: String,
                required: false,
                default: 'Rangliste der Company Challenge',
            },
            all: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data() {
            return {
                users: null,
                loading: false,
                error: null,
                company_name:'',
                challenge:'..',
            }
        },
        computed: {
            
        },
        methods: {
            convertToGermanFormat(dateString) {
                // Split the date string into components
                const [year, month, day] = dateString.split('-');
                // Return the date in German format
                return `${day}.${month}.${year}`;
            },
        },

        mounted() {
            this.loading = true;

            leaderboard.getCompanysteps(
                this,
                this.all,
                data => {
                    this.users = data.users;
                    this.company_name = data.company;
                    this.challenge = data.challenge;
                },
                () => this.error = 'Es ist ein Fehler aufgetreten',
                () => this.loading = false,
            );
        }
    }
</script>

<style scoped>
.kgk-text {
    max-width: 700px;
    margin:20px auto 0 auto;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped lang="scss">
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
</style>-->
